import { render, staticRenderFns } from "./PageAssetList.vue?vue&type=template&id=4b68f077"
import script from "./PageAssetList.vue?vue&type=script&lang=js"
export * from "./PageAssetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports